const UsageMessage = ({value = ''}) =>{
  return `This ${value} is already being used and therefore cannot be deleted.`;
};
export default UsageMessage;
